cb.define([], function () {
  var AA_aa_grade_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
    	viewmodel.on('afterLoadData', function() {
    		var mode = viewmodel.getParams().mode;
    		if(mode === "browse")
    		{
           self.setReadalbe(viewmodel);
			  }
    		else if (mode === "edit")
			  {
				   viewmodel.get("btnSaveAndAdd").setVisible(false);
			  }
    		if(mode == "edit")
    		{
    		   var storeModel = viewmodel.get('Stores');
    		   var storeRows = storeModel.getRows();
    		   storeRows.forEach(function(row, index){
    			       storeModel.setCellState(index, 'code', 'disabled', true);
    			       storeModel.setCellState(index, 'storeType', 'disabled', true);
    			       storeModel.setCellState(index, 'address', 'disabled', true);
    		   })
    		}
     });
     viewmodel.getGridModel().setShowCheckbox(false);
     viewmodel.get('Grades').on('beforeInsertRow', function (data) {
       var time = new Date().getHours() + ':00:00';
       data.row.startTime = time;
       data.row.endTime = time;
     });
   }
  }
  try {
    module.exports = AA_aa_grade_VM_Extend;
  } catch (error) {

  }
  return AA_aa_grade_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_grade_VM.Extend.js